import { useEffect } from 'react';

import { DontExistsItem } from '../../../components/DontExistsItem';
import { DontExistsItemFlex } from '../../../components/DontExistsItem/styles';
import { ListLinkedTanks } from '../../../components/List/ListLinkedTanks';
import { LoadingData } from '../../../components/LoadingData';
import { InfoTank } from '../../../components/Modal/InfoTank';
import { PageHeader } from '../../../components/PageHeader';
import { Paginator } from '../../../components/Paginator';
import { useLinkedTankContext } from '../../../context/ProviderPage/TanquesVinculado';
import { usePageContext } from '../../../context/usePage';
import { ContainerPage, PageContent } from '../../../styles/global.styles';

const TanquesVinculados = () => {
  const { setSelectedPage } = usePageContext();

  const {
    loadingLinkedTank,
    loadLinkedTankAction,
    tank,
    openSideModalFilterLinkedTankAction,
    openInfo,
    setOpenInfo,
    setOfsset,
    limit,
    offset,
    quantity,
    page,
    setPage,
    setHasClick,
    start,
    setStart,
  } = useLinkedTankContext();

  useEffect(() => {
    setSelectedPage({ option: 'tanquesVinculado' });
    loadLinkedTankAction();
  }, []);

  return (
    <>
      <PageHeader
        pageIcon={{ option: 'tanquesVinculado' }}
        pageTitle="Tanques Vinculados"
        filterAction={openSideModalFilterLinkedTankAction}
      />

      <ContainerPage>
        <PageContent
          style={{
            justifyContent: `${
              loadingLinkedTank === true ? 'center' : 'space-between'
            }`,
          }}
        >
          {loadingLinkedTank ? (
            <LoadingData title="Buscando dados" />
          ) : (
            <>
              {tank.length === 0 ? (
                <DontExistsItemFlex>
                  <DontExistsItem title="Nenhum tanque foi encontrado!" />
                </DontExistsItemFlex>
              ) : (
                <>
                  <ListLinkedTanks data={tank} />
                  <Paginator
                    {...{
                      start,
                      setStart,
                      limitItens: limit,
                      offset,
                      page,
                      quantity,
                      setHasClick,
                      setOfsset,
                      setPage,
                      quantityShowed: tank.length,
                    }}
                  />
                </>
              )}
            </>
          )}
        </PageContent>
        <InfoTank
          option="tanque"
          titleModal="Tanque selecionado"
          isOpen={openInfo}
          closeModal={setOpenInfo}
        />
      </ContainerPage>
    </>
  );
};

export { TanquesVinculados };
